<template>
  <div class="hello">
    <div class="container-fluid">
      <div class="row">
        <div class="col-3 col-md-3">
          <h1>Liste des arrêts</h1>
          <input placeholder="Entrez votre adresse" v-model="user_query" class="mb-2">
          <v-select v-model="selected" :options="listCities" :clearable="false"></v-select>
          <br/>
          <button @click="Search()">Rechercher</button>
          <br>
          <br>
          <p v-if="msg_error">{{msg_error}}</p>
          <ul class="mcp-list">
            <template v-for="borne in bornes.slice(pagB, pagE)">
              <li v-if="borne.coords" :key="'borne' + borne.id">
                <button class="btn map-borne" @click="ShowMarker(borne.id)">{{ borne.no }}</button>
              </li>
            </template>
            <li v-if="bornes.slice(pagB - 10, pagE - 10).length > 0" class="mcp-btnlin">
              <button class="btn" @click="prevBornes">Précédent</button>
            </li>
            <li v-if="bornes.slice(pagE + 1, pagE + 10).length > 0" class="mcp-btnlin">
              <button class="btn" @click="nextBornes">Suivant</button>
            </li>
          </ul>
        </div>
        <div class="col-9 col-md-9">
          <l-map :zoom="zoom" :center="center" style="height: 800px; width: 100%" ref="map"></l-map>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import Vue from 'vue';
import vSelect from 'vue-select';
import {
  LMap,
  LTileLayer,
  LMarker,
  LPopup,
  LTooltip,
  LPolygon
} from "vue2-leaflet";

Vue.component('v-select', vSelect)

export default {
  name: "Map",
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    LPolygon,
    LTooltip,
  },
  data() {
    return {
      msg: "Maria Express",
      zoom: 11,
      center: latLng(48.7143655, -72.5855239),
      mapOptions: {
        zoomSnap: 0.5
      },
      selected: "Dolbeau-Mistassini",
      listCities: ['Dolbeau-Mistassini', 'Saint-Félicien', 'Saint-Stanislas'],
      bornes: [],
      user_query: "",
      pagB: 0,
      pagE: 10,
      msg_error: null
    };
  },
  mounted() {
    this.InitCities();
    this.InitMap();
    this.InitMarkers();
  },
  methods: {
    InitCities: function() {
      this.$set(this, 'listCities', [])
      this.$http.get(this.$url_name + "/city/", {
        headers: {"Content-Type": "application/json"}
      })
      .then(response => {
        response.data.forEach((item) => {
          this.listCities.push(item.name)
        })
      })
      .catch(() => {
        this.$set(this, 'listCities', ['Dolbeau-Mistassini', 'Saint-Félicien', 'Saint-Stanislas'])
      });
    },
    InitMap: function() {
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {maxZoom: 19}).addTo(this.$refs.map.mapObject);
      L.tileLayer("https://{s}.tile.openstreetmap.se/hydda/roads_and_labels/{z}/{x}/{y}.png",{maxZoom: 18}).addTo(this.$refs.map.mapObject);
    },
    InitMarkers: function() {
      this.$http.get(this.$url_name + "/marker/", {
        headers: {"Content-Type": "application/json"}
      })
      .then(response => {
        this.bornes = response.data;
        this.UpdateMarkers();
      })
      .catch(err => {
        this.msg_error = 'Une erreur s\'est produite, réessayez plus tard.'
      });
    },
    prevBornes: function () {
      this.pagB = this.pagB - 10
      this.pagE = this.pagE - 10
    },
    nextBornes: function () {
      this.pagB = this.pagB + 10
      this.pagE = this.pagE + 10
    },
    ShowMarker: function(borne_id) {
      for (var i = 0; i <= this.bornes.length - 1; i++) {
        if (borne_id == this.bornes[i].id) {
          try {
            var latLngs = [this.bornes[i].marker.getLatLng()];
            var markerBounds = L.latLngBounds(latLngs);
            this.$refs.map.mapObject.fitBounds(markerBounds);
          } catch (e) {
            console.log("catch : ", e)
          }
          break;
        }
      }
    },
    Search: function() {
      this.msg_error = null
      this.$http
        .get(this.$url_name + "/marker-nearest/", {
          headers: {"Content-Type": "application/json"},
          params: {address: this.user_query + ' ' + this.selected}
        })
        .then(response => {
          this.bornes = response.data.results;
          this.UpdateMarkers();
        })
        .catch(err => {
          this.bornes = []
          this.msg_error = 'Désolé, impossible de trouver cette adresse.'
        });
    },
    UpdateMarkers: function() {
      var bounds = [];
      var bornes_icon = L.icon({
        iconUrl: require('../assets/map-icon.png'),
        shadowUrl:"",
        iconSize: [32, 41], // size of the icon
        shadowSize: [50, 64], // size of the shadow
        iconAnchor: [16, 40], // point of the icon which will correspond to marker's location
        shadowAnchor: [4, 62], // the same for the shadow
        popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
      });

      for (var i = 0; i <= this.bornes.length - 1; i++) {
        if (this.bornes[i].coords) {
          var marker = L.marker(
            [this.bornes[i].coords[1], this.bornes[i].coords[0]],
            { icon: bornes_icon }
          ).addTo(this.$refs.map.mapObject);

          var customPopup = "No de borne: " + this.bornes[i].no;
          marker.bindPopup(customPopup);

          this.bornes[i].marker = marker;

          bounds.push([this.bornes[i].coords[1], this.bornes[i].coords[0]]);
        }
      }

      this.$refs.map.mapObject.flyToBounds(bounds);
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1{
    font-size:30px;
    font-weight: normal;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .mcp-list li{
    display:block
  }
  .mcp-list li.mcp-btnlin{
    display:inline-block;
    padding:10px 0
  }
  .mcp-btn,
  .mcp-list li.mcp-btnlin .btn{
    background-color:#3185b8;
    border:2px solid #3185b8;
    border-radius:5rem;
    color:#fff;
    font-size:13px;
    text-transform:uppercase;
    white-space:nowrap;
    padding:0.5rem 1rem
  }
  .mcp-btn:hover,
  .mcp-list li.mcp-btnlin .btn:hover{
    background-color:transparent;
    color:#3185b8;
  }
  .mcp-btn:active,
  .mcp-list li.mcp-btnlin .btn:active{
    background-color:transparent;
    border-color:#eb600a;
    color:#eb600a
  }
</style>



// WEBPACK FOOTER //
// src/components/Map.vue